import { useState } from "react";
import { useFormik } from "formik";
import InputField from "../../../components/ui/form/InputField";
import Button from "../../../components/ui/utils/Button";
import { BiLogIn, BiPhone, BiLock } from "react-icons/bi";
import { Helmet } from "react-helmet";
import apiRequest from "../../../utils/towerHeadAdmin/apiRequest";
import toast from "react-hot-toast";
import authManager from "../../../utils/towerHeadAdmin/authManager";
import { useNavigate } from "react-router-dom";
import { DASHBOARD_ROUTE, FORGOT_ROUTE } from "../../../routes/towerHeadAdmin/towerHeadAdminRoutes";
import  { LoginImg,LogoMain } from "../../../utils/helper";

const Login = () => {
  const [serverErrors, setServerErrors] = useState({});
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      mobile: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.mobile) errors.mobile = "Mobile / User ID required";
      if (!values.password) errors.password = "Password required";
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const response = await apiRequest.login({
          body: {
            mobile: values.mobile,
            password: values.password,
          },
        });

        const data = response.data?.data;
        setServerErrors({});
        authManager.setTowerHeadAdminAccessToken(data?.token);

        toast.success("Login successful!");
        navigate(DASHBOARD_ROUTE);
      } catch (error) {
        setServerErrors(error?.response?.data?.data || {});
        toast.error(error?.response?.data?.message || "Login failed");
      }
    },
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-blue-50 to-green-100">
      <Helmet>
        <title>Corporate Head Admin Login</title>
      </Helmet>

      <div className="grid lg:grid-cols-2 min-h-screen">
        
        <div className="hidden lg:block relative">
          <img
            src={LoginImg}
            className="w-full h-full object-cover"
            alt="Admin Login"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40">
             <img className="h-[100px] rounded-full shadow" src={LogoMain} alt="logo" />
            <h1 className="text-white text-4xl font-bold drop-shadow">Welcome Back</h1>
          </div>
        </div>

        <div className="flex items-center justify-center p-6">
          <div className="w-full max-w-md bg-white/80 shadow-xl backdrop-blur-md rounded-3xl p-8">
            
            <div className="text-center mb-8">
              <div className=" rounded-full flex items-center justify-center mx-auto mb-4">
                 <img className="h-[100px] rounded-full border-red-500 shadow" src={LogoMain} alt="logo" />
              </div>
              <h2 className="text-2xl bg-green-100 py-2 b font-semibold text-black-500 rounded-full shadow">Tower Admin Head Login</h2>
            </div>

            <form onSubmit={formik.handleSubmit} className="space-y-6">
              
              <div className="relative">
                <InputField
                  label="Mobile / User ID"
                  id="mobile"
                  type="text"
                  placeholder="Enter mobile or user ID"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  error={formik.touched.mobile && formik.errors.mobile}
                  serverError={serverErrors.mobile}
                />
                <BiPhone className="absolute right-3 top-9 text-gray-400" />
              </div>

              <div className="relative">
                <InputField
                  label="Password"
                  id="password"
                  type="password"
                  placeholder="Enter Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && formik.errors.password}
                  serverError={serverErrors.password}
                />
                <BiLock className="absolute right-3 top-9 text-gray-400" />
              </div>

              <div className="flex justify-end -mt-3">
                <button
                  type="button"
                  onClick={() => navigate(FORGOT_ROUTE)}
                  className="text-sm text-emerald-600 hover:text-emerald-700 underline"
                >
                  Forgot Password?
                </button>
              </div>

              <Button
                type="submit"
                className="w-full bg-gradient-to-r from-emerald-500 to-blue-500 text-white font-semibold py-3 rounded-xl"
              >
                Login
              </Button>

            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
